export default __webpack_public_path__ + "static/media/char_body_001.97b1dba4.png";